export default __webpack_public_path__ + "static/media/cover-b.0e2fab70.jpg";